<template>
	<footer class="zui-footer english-footer">
		<cms-column id="555" class="links" @loaded="columnLoaded">
			<template slot-scope="{data}">
				<div class="erweima flex-footer">
					<div class="left">
						<div class="text">
							Honor
						</div>
						<div class="top">
							<logo type="footer1" class="footer-img" href="/"></logo>
							<logo type="footer3" class="footer-img" href="/"></logo>
							<logo type="footer4" class="footer-img" href="/"></logo>
							<logo type="footer2" class="footer-img" href="/"></logo>
							<logo type="footer5" class="footer-img" href="/"></logo>
						</div>
					</div>
					<div class="right">
						<div class="top_en">
							<p>Contact Us</p>
							<p>Mt. Emei Scenic Area</p>
							<p>Address: No. 41. South Mingshan Road, Emeishan City. Sichuan Province</p>
							<p>Postal Code: 614200</p>
							<p>Hotline: 400-8196-333</p>
							<p>E-mail: webmasteraems517.com</p>
						</div>
					</div>
				</div>
				<div class="contact">
					<!-- <div class="yellowText"><a href="http://www.ems517.com/old" target="_blank">本网站为峨眉山旅游网测试版　　　　　点此可前往原峨眉山旅游网</a></div> -->
					<p class="copy-right">
						Copyright 2023 Emei Mountain Tourism Co., Ltd. all rights reserved.
					</p>
					<p class="copy-right">
						C2002-2023 1CP证:蜀1CP备05027028号-9 川预审8LV-44BD-82BP-8R60号 川公网安备51118102000148号
					</p>
				</div>
			</template>
		</cms-column>
	</footer>
</template>
<script>
	import './less/footer.css'
	import Logo from './Logo'
	import {
		getArticles
	} from '../api/CmsApi'
	export default {
		components: {
			Logo
		},
		data() {
			return {
				copyrightList: [],
				linkList: [],
				linkObject: {
					name: '',
					index: '',
					children: []
				}
			}
		},
		mounted() {
			this.getLinkList()
		},
		methods: {
			weiboClick(data) {
				window.open(data.ext2value);
			},
			columnLoaded(data) {
				if (data.note) {
					this.copyrightList = data.note.split(/\n/);
				}
			},
			touristsClick() {
				if (this.$route.path === '/visitor') {
					document.body.scrollTop = document.documentElement.scrollTop = 0;
				} else {
					this.$openNewWindow('/new/visitor?tourists=1');
				}
			},
			getLinkList() {
				// 获取友情链接下拉选
				getArticles({
					page: 1,
					limit: 99,
					cateId: '99',
					sortBy: 1
				}).then(res => {
					const list = res.data.records || [];
					if (list.length > 0) {
						this.$set(this.linkObject, 'name', list[0].title);
						this.$set(this.linkObject, 'index', list[0].id);
					}
					this.linkList = list;
				})
			},
			linkSelect(key) {
				const link = this.linkList.find(a => a.id === key);
				window.open(link.ext1);
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/english_footer.vue